import { useNavigate } from 'react-router-dom';
import { CTAButton } from '../components/CTAButton';
import { ProgressDots } from '../components/ProgressDots';
import { useFlow } from '../state/flowStore';
import { SKIN_GOALS, type SkinGoal } from '../lib/types';

const MAX_GOALS = 3;

export function FocusScreen() {
  const nav = useNavigate();
  const { goals, setGoals } = useFlow();

  function toggle(id: SkinGoal) {
    const isSel = goals.includes(id);
    if (isSel) setGoals(goals.filter(g => g !== id));
    else if (goals.length < MAX_GOALS) setGoals([...goals, id]);
  }

  return (
    <div className="lume-bg min-h-svh flex flex-col">
      <ProgressDots current={1} total={2} />
      <div className="px-7 pt-10 flex-1 flex flex-col">
        <h1 className="text-headline text-text">What do you want to focus on?</h1>
        <p className="text-body text-text-secondary mt-2">
          Pick up to {MAX_GOALS}. We'll prioritise these in your routine.
        </p>

        <div className="mt-6 grid grid-cols-2 gap-2.5">
          {SKIN_GOALS.map(g => {
            const sel = goals.includes(g.id);
            return (
              <button
                key={g.id}
                type="button"
                onClick={() => toggle(g.id)}
                className={`text-left px-3.5 py-3 rounded-card transition ${
                  sel
                    ? 'bg-accent/10 text-accent ring-1 ring-accent/50'
                    : 'bg-surface text-text-secondary ring-1 ring-transparent'
                }`}
              >
                <span className="text-label">{g.label}</span>
              </button>
            );
          })}
        </div>

        <div className="flex-1" />

        <CTAButton
          label="Continue"
          disabled={goals.length === 0}
          onClick={() => nav('/camera')}
        />
        <div className="h-12" />
      </div>
    </div>
  );
}
